import API from "./Main";

export const getTrays = () => {
    return API.get('/number-trays')
}

export const deleteTrays = () => {
    return API.delete('/number-trays')
}